import { render } from "./SelectCourseComponent.vue?vue&type=template&id=56418082&scoped=true"
import script from "./SelectCourseComponent.vue?vue&type=script&lang=js"
export * from "./SelectCourseComponent.vue?vue&type=script&lang=js"

import "./SelectCourseComponent.vue?vue&type=style&index=0&id=56418082&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56418082"]])

export default __exports__